import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BuilderComponent } from './builder/builder.component';
import { PreviewComponent } from './preview/preview.component';
import { MapCreateComponent } from './map-create.component';

import { MessageModule } from '../../../shared/message/message.module';

import { CommonModule } from '../common/common.module';
import {SharedModule} from '../../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MessageModule,
    SharedModule
  ],
  declarations: [BuilderComponent, PreviewComponent, MapCreateComponent]
})
export class MapCreateModule { }
